import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

// const GreenCheckbox = withStyles({
//   root: {
//     color: green[400],
//     "&$checked": {
//       color: green[600],
//     },
//   },
//   checked: {},
// })((props) => <Checkbox color="default" {...props} />);

function CheckBox({ value, onChange, label, name }) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          onChange={onChange ? onChange : null}
          name={name}
          checked={value}
          color="primary"
        />
      }
      label={label}
    />
  );
}

export default CheckBox;
